import app from 'flarum/common/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
export default class ModalModal extends Modal {
  className() {
    const size = this.attrs.modal.size();
    return 'ModalModal Modal--' + size;
  }
  title() {
    return this.attrs.modal.title();
  }
  content() {
    return [m("div", {
      className: "Modal-body"
    }, this.body()), m("div", {
      className: "Modal-footer"
    }, this.footer())];
  }
  body() {
    const content = this.attrs.modal.content();
    return m('[', null, m.trust(content));
  }
  footer() {
    return m('[', null, this.footerItems().toArray());
  }
  footerItems() {
    const items = new ItemList();
    items.add('dismiss', m(Button, {
      className: "Button",
      onclick: () => this.hide()
    }, app.translator.trans('glowingblue-modals.lib.modal.dismiss_button')));
    const ctaButton = this.callToActionButton();
    if (ctaButton) {
      items.add('cta', ctaButton);
    }
    return items;
  }
}
flarum.reg.add('glowingblue-modals', 'common/components/ModalModal', ModalModal);